import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userPoints: null,
  pointsLoaded: false,
};

export const PointsSlice = createSlice({
  name: "points",
  initialState,
  reducers: {
    setUserPoints: (state, action) => {
      state.userPoints = action.payload;
      state.pointsLoaded = true;
    },
    clearUserPoints: (state) => {
      state.userPoints = null;
      state.pointsLoaded = false;
    },
  },
});

export const { setUserPoints, clearUserPoints } = PointsSlice.actions;
export default PointsSlice.reducer;
